import { Component, Element, h, Listen, Prop, State } from '@stencil/core';
import { Logger } from '../../global/_types';
import { DevLayoutNavigation } from './dev-layout-navigation';

@Component({
  tag: 'dev-layout-header',
  shadow: false
})

export class DevLayoutHeader {
  @Element() host: HTMLElement;

  @Prop() config: string | DevLayoutHeaderConfig;
  @Prop() debug: boolean = false;

  @State() selected: DevLayoutNavigation[] = [];

  private logger: Logger;

  /* Config */
  private options: DevLayoutHeaderConfig;

  /* Elements */
  private headerContent: HTMLElement;
  private headerNavigationApp: HTMLElement;
  private navBar: HTMLElement;
  private bodyContainer: HTMLElement;

  // Lifecycle
  componentWillLoad() {
    this.logger = new Logger(this.debug, 'DevLayoutHeader');

    this.options = typeof (this.config) === 'string' ?
      JSON.parse(this.config) as DevLayoutHeaderConfig :
      this.config;
  }

  componentDidLoad() {
    const parent = document.querySelector(this.options.parentTag).shadowRoot;
    this.headerNavigationApp = this.host.querySelector('#headerNavigationApp');
    this.navBar = this.host.querySelector('nav.navbar');
    this.headerContent = document.querySelector('.headerContent')
      || parent.querySelector('.headerContent');
    this.bodyContainer = document.querySelector('#page-placed-content')
      || parent.querySelector('#page-placed-content');
    this.setMenuHeight();

    this.logger.trace('DevLayoutHeader loaded');
  }

  setMenuHeight() {
    if (!this.headerNavigationApp) return;
    const setHeight = this.headerNavigationApp.offsetHeight != 0 ? this.headerNavigationApp.offsetHeight : this.navBar.offsetHeight;
    if (this.headerContent) {
      this.headerContent.style.paddingTop = setHeight + 'px';
    } else if (this.bodyContainer){
      this.bodyContainer.style.paddingTop = setHeight + 'px';
    }
  }

  @Listen('resize', { target: 'window' })
  updateViewport() {
    this.setMenuHeight();
  }

  @Listen('scroll', { target: 'window' })
  @Listen('resize', { target: 'window' })
  hideMainNav() {
    if (!this.headerNavigationApp) return;
    if (window.scrollY >= 0.1) {
      if (this.headerNavigationApp.classList.contains('hidden')) {
        return;
      }
      this.headerNavigationApp.classList.add('hidden');
      this.setMenuHeight();
    } else {
      this.headerNavigationApp.classList.remove('hidden');
      this.setMenuHeight();
    }
  }

  // Render
  render() {
    const navConfig = {
      "data": {
        'meta': this.options.metaNav,
        'primary': this.options.primaryNav
      },
      "type": "header"
    };

    const mobileNavConfig = {
      "data": {
        'primary': this.options.primaryNav
      },
      "type": "headerMobile"
    };

    return ([
      // ToDo: Country select
      <div class="countrySelect">
        <a class="button" id="BTNcountryClose"><span class="icon-raticons icon-close" /></a>
        <div class="container">
          <div class="row">
            <div class="col-sm-6 continent-col">
              <select id="choose-continent" name="choose-continent" class="selectpicker bs-select-hidden">
                <option value="-1">Select a continent</option>
                <option value="1319">Americas</option>
                <option value="1318">Europe</option>
              </select>
              <div class="btn-group bootstrap-select">
                <button type="button" class="btn dropdown-toggle btn-default" data-toggle="dropdown"
                        data-id="choose-continent" title="Select a continent"><span class="filter-option pull-left">Select a continent</span>&nbsp;
                  <span class="caret" /></button>
                <div class="dropdown-menu open">
                  <ul class="dropdown-menu inner" role="menu">
                    <li data-original-index="0" class="selected"><a tabIndex={0} class=""
                                                                    data-tokens="null"><span class="text">Select a continent</span><span
                      class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="1"><a tabIndex={0} class="" data-tokens="null"><span
                      class="text">Africa</span><span class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="2"><a tabIndex={0} class="" data-tokens="null"><span
                      class="text">Americas</span><span class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="3"><a tabIndex={0} class="" data-tokens="null"><span
                      class="text">Asia</span><span class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="4"><a tabIndex={0} class="" data-tokens="null"><span
                      class="text">Oceania</span><span class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="5"><a tabIndex={0} class="" data-tokens="null"><span
                      class="text">Europe</span><span class="glyphicon glyphicon-ok check-mark" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-6 country-col" id="choose-country-holder">
              <select id="choose-country" class="selectpicker bs-select-hidden" name="choose-country"
                      data-live-search="true" data-live-search-style="startsWith" title="Wählen Sie ein Land">
                <option class="bs-title-option" value="">Wählen Sie ein Land</option>
                <option value="110">Germany</option>
                <option value="114">United Kingdom</option>
                <option value="85">Other countries</option>
              </select>
              <div class="btn-group bootstrap-select">
                <button type="button" class="btn dropdown-toggle btn-default" data-toggle="dropdown"
                        data-id="choose-country" title="Wählen Sie ein Land"><span class="filter-option pull-left">Wählen Sie ein Land</span>&nbsp;
                  <span class="caret" /></button>
                <div class="dropdown-menu open">
                  <div class="bs-searchbox"><input type="text" class="form-control" autoComplete="off" /></div>
                  <ul class="dropdown-menu inner" role="menu">
                    <li data-original-index="40"><a tabIndex={0} class="" data-tokens="null"><span
                      class="text">Germany</span><span class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="117"><a tabIndex={0} class="" data-tokens="null"><span class="text">United Kingdom</span><span
                      class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="118"><a tabIndex={0} class="" data-tokens="null"><span class="text">United States</span><span
                      class="glyphicon glyphicon-ok check-mark" /></a></li>
                    <li data-original-index="123"><a tabIndex={0} class="" data-tokens="null"><span class="text">Other countries</span><span
                      class="glyphicon glyphicon-ok check-mark" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-4" id="choose-language-holder" style={{ display: 'none' }}>
              <select id="choose-language" style={{ display: 'none' }} class="selectpicker bs-select-hidden"
                      name="choose-language" />
              <div class="btn-group bootstrap-select">
                <button type="button" class="btn dropdown-toggle btn-default" data-toggle="dropdown"
                        data-id="choose-language" title="Nothing selected"><span class="filter-option pull-left">Nothing selected</span>&nbsp;
                  <span class="caret" /></button>
                <div class="dropdown-menu open">
                  <ul class="dropdown-menu inner" role="menu" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      <div id="center-of-screen" style={{ position: 'relative', top: '0', left: '0', width: '100%', height: '100%' }} />,
      navConfig.data ?
        <dev-layout-navigation debug={true} config={JSON.stringify(navConfig)} />
        : '' ,

      this.options.inPageNav ?
        <cms-inpage-navigation
          debug={true}
          config={JSON.stringify(this.options.inPageNav)}
        />
        : '',

      mobileNavConfig.data?.primary ?
        <dev-layout-navigation debug={true} config={JSON.stringify(mobileNavConfig)} />
        : ''
    ]);
  }
}

export interface DevLayoutHeaderConfig {
  metaNav: DevLayoutNavigation[] | null;
  primaryNav: DevLayoutNavigation[] | null;
  inPageNav: boolean | false;
  parentTag: string;
}
